import React from "react"
import { FormattedMessage } from "react-intl"
import { Divider, Modal } from "@walmart-web/livingdesign-components"
import { AdministrationOptions } from "components/UserManagement/interfaces"
import "./index.scss"
import { SectionProps } from "components/UserManagement/constants"
import Button from "components/Shared/Button"

interface DeleteProps {
	section: AdministrationOptions
	isOpen: boolean
	onClose: () => void
	selection: any
	refetch: () => Promise<any>
}

const Delete: React.FC<DeleteProps> = ({
	section,
	isOpen,
	onClose,
	selection,
	refetch,
}) => {
	const textId = `phronesis.usermanagement.${section}.modal.`
	const value = selection ? selection[SectionProps[section].id] : null
	const endpoint = SectionProps[section].endpoint.delete
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={<FormattedMessage id={textId + "title"} />}
			UNSAFE_className="administration-delete-modal"
		>
			<div className="text">
				<FormattedMessage
					id={textId + "content"}
					values={{ name: value, b: (value: string) => <b>{value}</b> }}
				/>
			</div>

			<Divider UNSAFE_className="divider" />

			<div className="buttons">
				<Button variant="tertiary" onClick={onClose}>
					<FormattedMessage id="phronesis.usermanagement.cancel" />
				</Button>
				<Button
					variant="destructive"
					onClick={() => {
						endpoint(selection).then(() => {
							onClose()
							refetch()
						})
					}}
				>
					<FormattedMessage id={textId + "button"} />
				</Button>
			</div>
		</Modal>
	)
}

export default Delete
